import { useEffect, useState } from "react";
import { createTheme, useMediaQuery } from "@mui/material";

import { ScreenType } from "../../../utils/breakpoints";
import { delay } from "../../../utils";

import ProgramCard from "../../onboarding/Components/ProgramCard";
import ProgramDetail from "../../onboarding/Components/ProgramDetail";
import CloseButton from "../../../common/CloseButton";
import PaddedContentArea from "../../../common/PaddedContentArea";

function Programs(props) {
    const { programs = [] } = props;
    const screenSize = ScreenType(useMediaQuery);

    const [sortedPrograms, setSortedPrograms] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [delaySlide, setDelay] = useState(null);
    const [slide, setSlide] = useState(false);

    const theme = createTheme({
        breakpoints: {
            values: {
                lg: 1025,
                xl: 1340,
            },
        },
    });
    const matchesLow = useMediaQuery(theme.breakpoints.down("lg"));
    const matchesLG = useMediaQuery(theme.breakpoints.down("xl"));
    const matchesXL = useMediaQuery(theme.breakpoints.up("xl"));


    let grid;
    if (matchesLow) {
        grid = 6;
    } else if (matchesLG) {
        grid = 4;
    } else if (matchesXL) {
        grid = 3;
    }

    useEffect(() => {
        const order = {
            strength: 1,
            mobility: 2,
            focus: 3,
            athletics: 4,
        };
        let tempList = [];
        for (let x = 0; x < programs?.length; x++) {
            tempList?.push({
                ...programs[x],
                order: order[programs[x]?.type]
            })
        }

        tempList = tempList?.sort((a, b) => a.order - b.order);
        setSortedPrograms(tempList);
    }, [programs?.length]);

    // strength, mobility, focus,
    //     athletics


    return (
        <div id="program-intro-v2" className="program-detail">
            <div id="onboarding-v2">
                <div id="programs" className="fpc">
                    <div className="fpc-header">
                        <h4>Programs</h4>
                    </div>
                    <div className="fpc-content">
                        <div id="programs-list" className="row">
                            {
                                sortedPrograms?.map((program, i) => {

                                    return (
                                        <ProgramCard
                                            key={"pc-i-" + i}
                                            program={program}
                                            grid={grid}
                                            onClick={() => {
                                                clearTimeout(delaySlide);
                                                setSelectedProgram(program);
                                                setSlide(true);
                                            }} />
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                <div id="slider-modal-div" style={{ top: slide ? "0" : "100%" }}>
                    <PaddedContentArea>
                        <CloseButton
                            onClick={() => {
                                setSlide(false);
                                delay(() => {
                                    setSelectedProgram(null);
                                }, 300);
                            }}
                        />
                        {selectedProgram && (
                            <ProgramDetail
                                updateAddedPrograms={() => { }}
                                selectedProgram={selectedProgram}
                                setSelectedProgram={setSelectedProgram}
                                setAddedProgram={() => {
                                }}
                                screenSize={screenSize}
                                back={() => {
                                    setSlide(false);
                                    setDelay(
                                        delay(() => {
                                            setSelectedProgram(null);
                                        }, 300)
                                    );
                                }}
                            />
                        )}
                    </PaddedContentArea>
                </div>
            </div>
        </div >
    );
}

export default Programs;